import { createContext, useContext, useState } from "react";

const PaymentTypeContext = createContext(undefined);

export const usePaymentType = () => {
  const context = useContext(PaymentTypeContext);

  if (!context) {
    throw new Error("usePaymentType must be within PaymentTypeProvider");
  }

  return context;
};

export const PaymentTypeProvider = ({ children }) => {
  const [paymentType, setPaymentType] = useState("BNB");

  const setGlobalPaymentType = (val) => setPaymentType(val);

  return (
    <PaymentTypeContext.Provider value={{ paymentType, setGlobalPaymentType }}>
      {children}
    </PaymentTypeContext.Provider>
  );
};
